import { ID_QUERY, CommonRes } from './common';

export interface CategoryResItem extends CommonRes {
  name: string;
  description?: string;
  metaTitle: string;
  metaDescription: string;
  slug: string;
}

export class Category {
  id: string;
  name: string;
  slug: string;
  description?: string;

  constructor(item: CategoryResItem) {
    this.id = item.sys.id;
    this.name = item.name;
    this.slug = item.slug;
  }
  static getQuery = () => {
    return `
      query {
        categoryCollection(
          limit: 1000
        ){
          items{
            ${ID_QUERY}
            name
            description
            metaDescription
            metaTitle
            slug
          }
        }
      }
    `;
  };
}
